import { render, staticRenderFns } from "./UploadLessons.vue?vue&type=template&id=6dd01df2&scoped=true"
import script from "./UploadLessons.vue?vue&type=script&lang=ts"
export * from "./UploadLessons.vue?vue&type=script&lang=ts"
import style0 from "./UploadLessons.vue?vue&type=style&index=0&id=6dd01df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd01df2",
  null
  
)

export default component.exports